import config from "../_helpers/config";
import { getAsync } from "../_helpers/adapters";

export const getTerms = async () =>
  getAsync(`${config.apiUrl}/terms/`).then(res => res.terms);